import React, { Fragment } from 'react';
import APIKeyView from './APIKeyView';

const ViewAPIKey = () => {
    return (
        <Fragment>
            <APIKeyView />
        </Fragment>
    );
};

export default ViewAPIKey;
